var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 36.6654C29.2049 36.6654 36.6668 29.2034 36.6668 19.9987C36.6668 10.794 29.2049 3.33203 20.0002 3.33203C10.7954 3.33203 3.3335 10.794 3.3335 19.9987C3.3335 29.2034 10.7954 36.6654 20.0002 36.6654Z",
    stroke: "#ADAAE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.6667V20",
    stroke: "#ADAAE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.332H20.0167",
    stroke: "#ADAAE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjAwMDIgMzYuNjY1NEMyOS4yMDQ5IDM2LjY2NTQgMzYuNjY2OCAyOS4yMDM0IDM2LjY2NjggMTkuOTk4N0MzNi42NjY4IDEwLjc5NCAyOS4yMDQ5IDMuMzMyMDMgMjAuMDAwMiAzLjMzMjAzQzEwLjc5NTQgMy4zMzIwMyAzLjMzMzUgMTAuNzk0IDMuMzMzNSAxOS45OTg3QzMuMzMzNSAyOS4yMDM0IDEwLjc5NTQgMzYuNjY1NCAyMC4wMDAyIDM2LjY2NTRaIiBzdHJva2U9IiNBREFBRTMiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMCAyNi42NjY3VjIwIiBzdHJva2U9IiNBREFBRTMiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMCAxMy4zMzJIMjAuMDE2NyIgc3Ryb2tlPSIjQURBQUUzIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };